import React from 'react';
import '../App.less';
import { Link } from "react-router-dom";
import { 
    Button,
    Image,
    Typography, 
    Divider, 
    Statistic,
    Tag,
    Row, 
    Col,
    Space,
    PageHeader,
    Avatar,
    Alert
} from 'antd';

import { AntDesignOutlined } from '@ant-design/icons';

const { Text, Title } = Typography;



function sensable() {
  return (
    <div>
        <Row className="m48-b">
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
            <Col xs={22} sm={22} md={22} lg={18} xl={18}>
                <div className="">
                    <Row className="m24-b">
                        <Link to="/">
                            <PageHeader
                                onBack={() => null}
                                title="Back to Home"
                            />
                        </Link>
                    </Row>

                    <Row className="m16-b">
                        <Title>Sensable</Title>
                    </Row>

                    <Row className="m24-b m24-t">
                        <Text>
                        Sensable is a piece of smart jewelry which enables humans to explore and sense biotic and abiotic elements in the neighborhood. Sensable houses a plant, which is fostered by the wearer promoting green infrastructure and taking frequent walks to meet its light needs. The device acts as an interface between humans and non-humans, leading to an increase in empathy for the environment we are a part of. Sensable guides one to the nearest green area where one can experience ecology by encountering various sound sculptures and becoming a part of it. 
                        </Text>  
                    </Row>

                    <Row justify="space-between">
                        <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                            <Space size={4} direction="vertical">
                                <Text className="bitTitle">Advisors</Text>
                                <Text className="bitDesc">
                                    <a className="nameLinkColor" href="https://www.linkedin.com/in/johnlync/" target="_blank" rel="noopener noreferrer">John Lynch</a>,
                                    <a className="nameLinkColor" href="https://www.linkedin.com/in/alierose/" target="_blank" rel="noopener noreferrer"> Alie Rose</a>,
                                    <a className="nameLinkColor" href="https://www.linkedin.com/in/simonamaschi/" target="_blank" rel="noopener noreferrer"> Simona Maschi</a>
                                </Text>
                            </Space>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                            <Space size={4} direction="vertical">
                                <Text className="bitTitle">Team</Text>
                                <Text className="bitDesc">
                                    Individual
                                </Text>
                            </Space>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                            <Space size={4} direction="vertical" className="m24-t">
                                <Text className="bitTitle">Sustainable development goals</Text>
                                <Space>
                                    <Image className="sdgImage" src={`../pubAssets/sdg-15.png`}/>
                                    <Image className="sdgImage" src={`../pubAssets/sdg-3.png`}/>
                                    <Image className="sdgImage" src={`../pubAssets/sdg-10.png`}/>
                                    <Image className="sdgImage" src={`../pubAssets/sdg-11.png`}/>
                                </Space>
                                <Space>
                                    <Image className="sdgImage" src={`../pubAssets/sdg-12.png`}/>
                                    <Image className="sdgImage" src={`../pubAssets/sdg-13.png`}/>
                                    <Image className="sdgImage" src={`../pubAssets/sdg-16.png`}/>
                                </Space>
                            </Space>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                            <Space size={4} direction="vertical" className="m24-t">
                                <Text className="bitTitle">Tags</Text>
                                <Space size={1}>
                                    <Tag>Processing</Tag>
                                    <Tag>Arduino</Tag>
                                </Space>
                                <Space size={1}>
                                    <Tag>IoT</Tag>
                                    <Tag>Installation</Tag>
                                </Space>
                            </Space>
                        </Col>
                    </Row>

                    
                </div>
            </Col>
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
        </Row>
        <Row>
            <Col span={24}>
                    <div className="videoHeight">
                        <iframe src="https://player.vimeo.com/video/523529635?title=0&byline=0&portrait=0" className="vimeoChild" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                    </div>
            </Col>  
        </Row>
        
        <Row className="m80-t m80-b">
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
            <Col xs={22} sm={22} md={22} lg={18} xl={18}>
                <Row justify="space-between">
                            <Text className="projectTitle">Concept</Text>
                </Row>
                <Row className="m24-t">
                    <Text>
                        Smart jewelry that helps you sense the biosphere more closely. It houses a plant, which needs to be fostered, cared for and watered by you.
                        <br/><br/>
                        When it needs light, it will vibrate to nudge you to take your new friend out for a light walk. It will then lead you to the nearest green spaced wherein it will make you meet it's other non-human friends like the leaf-cutter ants, moisture in the soil etc.
                    </Text>
                </Row>

                <Row justify="space-between m48-t">
                    <div>
                        <Image src={require("../assets/projects/sensable/sensable_90.png")}/>
                    </div>
                </Row>

                <Row justify="space-between m48-t">
                    <Space size={16}>

                        <div>
                            <Image src={require("../assets/projects/sensable/sensable_88.jpg")}/>
                        </div>

                        <div>
                            <Image src={require("../assets/projects/sensable/sensable_87.jpg")}/>
                        </div>
                    </Space>
                </Row>

                <Row justify="space-between m16-t">
                    <Space size={16}>

                        <div>
                            <Image src={require("../assets/projects/sensable/sensable_85.jpg")}/>
                        </div>

                        <div>
                            <Image src={require("../assets/projects/sensable/sensable_86.jpg")}/>
                        </div>
                    </Space>
                </Row>
                
                <Row className="m80-t">
                    <Col>
                        <Row>
                            <Text className="projectTitle">Inspiration & Research</Text>
                        </Row>
                        <Row>
                            <Text className="m16-b m16-t">
                                I believe that human ego is the source of all evil and suffering in this world we exist in. Which is the root cause for ignorance as we tend to be driven by wants rather than needs. 
                                <br/><br/>
                                We tend to think of nature as something that is outside of us, as a broad entanglement of things that silently undergoes our actions and observation. But what if we see ourselves as part of an environment that senses us as much as it is sensed by us? Scientists increasingly find proof of communication networks, relations between plants, animals and humans that only few of us are aware of. Plants communicate the attack of caterpillars to other plants that will immediately produce chemical toxins. Trees communicate with each other through their roots. Even humans seem to communicate in a sensory environment in which plants and animals simultaneously take part.
                                <br/><br/>
                                Do you often wonder what plants and animals are thinking about the current state of our planet? If they could vote in a democratic election, what would they want to see change? What is important to them to stay the same? In considering your own perspective, what service do you feel is necessary to plants and animals to protect their home on Earth and create a healthy life for their species now and long-term beyond our generation?
                                <br/><br/>
                                Which led to me gravitating towards the following topic:
                            </Text>
                        </Row>
                        <Row>
                            <Text className="HMWWhite" >
                                Non-Anthropocentric Governance and Decision Making to reduce inequalities
                            </Text>
                        </Row>
                        
                        <Row justify="space-between m48-t">

                            <Col xs={22} sm={22} md={22} lg={12} xl={12}>
                                <Row>
                                    <Text className="m16-b">
                                        I wanted to know
                                    </Text>    
                                </Row>
                                <Row>
                                    <Text className="m16-b HMWWhite" >
                                        How do people see themselves in relation to the environment, nature, life around them?
                                    </Text>
                                </Row>
                                <Row>
                                    <Text className="m16-b">
                                        Since humans make up only 2.5% of biomass, I went on to try and understand what current outlook towards these non-humans is.
                                    </Text>    
                                </Row>
                                <Row justify="space-between m48-t">
                                    <Col xs={22} sm={22} md={22} lg={11} xl={11}>
                                        <div>
                                            <Image src={require("../assets/projects/sensable/sensable_9.gif")}/>
                                            <div  className="m16-t m16-b">
                                                <Text className="imgDesc">
                                                    I was stunned and inspired by these specimens I found online during my desk research
                                                </Text>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xs={22} sm={22} md={22} lg={11} xl={11}>
                                        <div>
                                            <Image src={require("../assets/projects/sensable/sensable_10.gif")}/>
                                            <div  className="m16-t m16-b">
                                                <Text className="imgDesc">
                                                    They were in a way amplifying the non-humans into something that could be perceived by humans
                                                </Text>
                                            </div>
                                        </div>
                                    </Col>
                                    
                                </Row>
                            </Col>
                            <Col xs={22} sm={22} md={22} lg={11} xl={11}>
                                <div>
                                    <Image src={require("../assets/projects/sensable/sensable_40.png")}/>
                                </div>
                                <div  className="m16-t m16-b">
                                                <Text className="imgDesc">
                                                    Even though we take up so less of the biomass, our actions impact the whole biome
                                                </Text>
                                 </div>
                            </Col>
                        </Row>
                        <Row>
                            <Text className="m48-t">
                                Urbanization is one of the primary drivers of biodiversity loss around the world, according to the Intergovernmental Science-Policy Platform on Biodiversity and Ecosystem Services (IPBES), with urban areas having doubled since 1992. By the middle of the century, the UN projects that 68% of humanity will live in towns and cities, placing further pressure on ecosystems and rapidly vanishing habitats
                            </Text>
                        </Row>
                        <Row justify="space-between" className="m48-t">
                            <Col xs={22} sm={22} md={22} lg={12} xl={12}>
                                <Row>
                                    <Text>
                                        I wanted to understand whose all decisions need to be taken to move to a better future. I started of by marking a 1m x 1m land in the garden to understand all the stakeholders of that small piece. I was amazed and overwhelmed by the outcome, there were plants at different stages of their lives, some were food, some weren't. More than the plant and animals, the rain, gardener and the wind too affected what came into that piece of land as nutrient.
                                    </Text>
                                </Row>
                                <Row>
                                    <Text>
                                    <br/><br/>
                                        During the research phase I tried to observe and absorb as much as I could
                                        <ul>
                                            <li><strong>Expert interviews </strong>with Andrew Quitmeyer(Digital Naturalist), Rebecca Mora(Biomimicry specialist) and Irene Garcia(Department of Innovation, Curridabat Mayor's office)</li>
                                            <li><strong>Intercept interviews </strong>with people in and around the neighborhood</li>
                                            <li><strong>Research papers </strong>on Eco-centrism and Human Eco-societal relationships</li>
                                            <li><strong>Podcasts </strong>from RadioLab on natural emergence</li>
                                            <li><strong>Walk around </strong>the neighborhood and Curridabat area</li>
                                        </ul>
                                    </Text>
                                </Row>
                            </Col>
                            <Col xs={22} sm={22} md={22} lg={11} xl={11}>
                                <div>
                                    <Image src={require("../assets/projects/sensable/sensable_41.png")}/>
                                </div>
                            </Col>
                            
                        </Row>
                        <Row className="m48-t">
                            <div>
                                <Image src={require("../assets/projects/sensable/sensable_43.png")}/>
                                <div  className="m16-t m16-b">
                                    <Text  className="imgDesc">
                                        The City of Curridabat has a initiative called as <strong>'Ciudad Dulce'</strong>(Sweet City), where in they've given citizenship to plants and animals. Not just that, they've created bio-corridors across the city to enable movement of biodiversity. The hut like structure int he above photo is a Bee Hotel. I was inspired by Ciudad Dulce and wanted my project to align with their goals, hence even aesthetically you will see hexagons everywhere - cuidad dulce branding.
                                    </Text>
                                </div>
                            </div>
                        </Row>
                        <Row className="m48-t">
                            <div>
                                <Image src={require("../assets/projects/sensable/sensable_44.png")}/>
                                <div  className="m16-t m16-b">
                                    <Text  className="imgDesc">
                                        Some photos from my walk around Curridabat, I amazed to find so much biodiversity in sprawling urban area. By the middle of the century, the UN projects that 68% of humanity will live in towns and cities, placing further pressure on ecosystems and rapidly vanishing habitats
                                    </Text>
                                </div>
                            </div>
                        </Row>
                        <Row className="m48-t" justify="space-between" align="start">

                            <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                                <div>
                                    <Image src={require("../assets/projects/sensable/sensable_63.png")}/>
                                    <div  className="m16-t m16-b">
                                        <Text  className="imgDesc">
                                            Elliott, Alejandro and myself at the Curridabat Municipality office
                                        </Text>
                                    </div>
                                </div>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                                <div>
                                    <Image src={require("../assets/projects/sensable/sensable_8.gif")}/>
                                    <div  className="m16-t m16-b">
                                        <Text  className="imgDesc">
                                            A wooden stage at the centre of a park at Curridabat, some people I spoke to said it looked like a natural amphitheater
                                        </Text>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <Row className="m48-t" justify="space-between" align="start">

                            
                            <Col xs={24} sm={24} md={24} lg={15} xl={15}>
                                <div>
                                    <Image src={require("../assets/projects/sensable/sensable_7.gif")}/>
                                    <div  className="m16-t m16-b">
                                        <Text  className="imgDesc">
                                            In the same park, I noticed a trail of ants, coming from the soil over the human pathway and back into the soil. A mature leaf-cutter ant nests houses around 8 million ants, this made me wonder, who gave priority to us 3 humans in the park at the moment over those ants
                                        </Text>
                                    </div>
                                </div>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                                <div>
                                    <Image src={require("../assets/projects/sensable/sensable_4.gif")}/>
                                    <div  className="m16-t m16-b">
                                        <Text  className="imgDesc">
                                            Ants trying to cross over the human path from soil
                                        </Text>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <Row className="m48-t" justify="space-between">

                            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                                
                                    <Image className="m48-t" src={require("../assets/projects/sensable/sensable_2.gif")}/>
                                    <div  className="m16-t m16-b">
                                        <Text  className="imgDesc">
                                            I put a paper on their trail to see, if they will cross over it. I wondered if I would be able to control their direction of exploration
                                        </Text>
                                    </div>
                                </Col>
                            
                                <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                                    <Image className="m48-t" src={require("../assets/projects/sensable/sensable_3.gif")}/>
                                    <div  className="m16-t m16-b">
                                        <Text  className="imgDesc">
                                            After 32 minutes, the ants were able to reclaim their trail by spraying a new line of pheromones. I could now move this paper and add another one.
                                        </Text>
                                    </div>
                                </Col>
                        </Row>



                        <Row className="m48-t" justify="space-between" align="start">

                            <Col span={24}>
                                <div>
                                    <Image src={require("../assets/projects/sensable/sensable_45.png")}/>
                                    <div  className="m16-t m16-b">
                                        <Text  className="imgDesc">
                                            I came back to see if I would be able to count the number of leaves harvested by them using ESP32 cam
                                        </Text>
                                    </div>
                                </div>
                            </Col>
                            
                        </Row>

                        <Row className="m48-t" justify="space-between">
                            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                                
                                <Image className="m48-t" src={require("../assets/projects/sensable/sensable_6.gif")}/>
                                    <div  className="m16-t m16-b">
                                        <Text  className="imgDesc">
                                            some pigeons I encountered during my walks, they would fly away when I neared them and come back to sit in the same place as I went away
                                        </Text>
                                    </div>
                            </Col>
                        
                            <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                                <Image className="m48-t" src={require("../assets/projects/sensable/sensable_46.png")}/>
                                    <div  className="m16-t m16-b">
                                        <Text  className="imgDesc">
                                            Some trees with name tags
                                        </Text>
                                    </div>
                            </Col>
                        </Row>

                        <Row className="m48-t">
                            <Text>I decided I would have to narrow down on my stakeholders to work with for the scope of this project as nature has many. Based on my research and field visits, I went on to select trees, soil, leaf-cutter ants, pigeons and humans as my 5 key stakeholders.</Text>
                        </Row>

                        <Row className="m48-t" justify="space-between" align="start">

                        <Image src={require("../assets/projects/sensable/sensable_42.png")}/>
                            
                        </Row>

                        
                        <Row className="m80-t">
                                    <Text>which brings me to my How Might We</Text>
                        </Row>

                        <Row className="m48-t" justify="space-between">
                            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                                <Row>
                                    <Text className="HMWDark">
                                        how might we bring non-humans and humans on the same conversation plane such that all stakeholders and futurity benefit from emergent behaviour
                                    </Text>
                                </Row>
                            
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={10} xl={10}>
                                <Row className="m48-t"><Text>I figured a 3 step approach would work best in this scenario for humans to know non-humans</Text></Row>
                                <Row justify="space-between">
                                    <Col span={7}>
                                        <Image className="m48-t" src={require("../assets/projects/sensable/sensable_102.png")}/>
                                        <div className="m16-t"><Text><strong>Identify</strong></Text></div>
                                    </Col>
                                    <Col span={7}>
                                        <Image className="m48-t" src={require("../assets/projects/sensable/sensable_103.png")}/>
                                        <div className="m16-t"><Text><strong>Empathize</strong></Text></div>
                                    </Col>
                                    <Col span={7}>
                                        <Image className="m48-t" src={require("../assets/projects/sensable/sensable_104.png")}/>
                                        <div className="m16-t"><Text><strong>Co-create</strong></Text></div>
                                    </Col>
                                </Row>
                            </Col>
                            
                        </Row>

                        

                        

                        <Row className="m120-t">
                            <Text className="projectTitle">Insights & Ideation</Text>
                        </Row>
                        <Row justify="space-between">
                            <Col xs={24} sm={24} md={24} lg={7} xl={7}>
                                <Image className="m48-t" src={require("../assets/projects/sensable/sensable_96.png")}/>
                                <div className="m16-t"><Text>Government and people both have aspiration to increase green infrastructure</Text></div>
                            </Col>

                            <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                                <Image className="m48-t" src={require("../assets/projects/sensable/sensable_97.png")}/>
                                <div className="m16-t"><Text>Sounds of nature are calming and help in de-stressing, especially after a long day</Text></div>
                            </Col>
                            
                            <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                                <Image className="m48-t" src={require("../assets/projects/sensable/sensable_98.png")}/>
                                <div className="m16-t"><Text>Empathizing with mistreated beings is the first step of an organized community</Text></div>
                            </Col>
                        </Row>
                        <Row justify="space-between" className="m48-t">
                            
                            <Col xs={24} sm={24} md={24} lg={7} xl={7}>
                                <Image className="m48-t" src={require("../assets/projects/sensable/sensable_99.png")}/>
                                <div className="m16-t"><Text>People feel the need to do their part for nature and give back, when they realize it’s importance</Text></div>
                            </Col>
                            
                            <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                                <Image className="m48-t" src={require("../assets/projects/sensable/sensable_100.png")}/>
                                <div className="m16-t"><Text>Nature’s will can only be witnessed and has strength in numbers</Text></div>
                            </Col>
                            
                            <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                                <Image className="m48-t" src={require("../assets/projects/sensable/sensable_101.png")}/>
                                <div className="m16-t"><Text>Urbanism is the primary driver of biodiversity loss across the world</Text></div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row className="m120-t">
                     <div>
                        <Image src={require("../assets/projects/sensable/sensable_47.png")}/>
                            <div  className="m16-t m16-b">
                                <Text>
                                    I went into ideation with my peers providing them a matrix of stakeholders to match and brainstorm for. I shared with them my insights and some of my field work findings
                                </Text>
                            </div>
                    </div>
                </Row>
                <Row className="m80-t">
                     <div>
                        <Image src={require("../assets/projects/sensable/sensable_48.png")}/>
                            <div  className="m16-t m16-b">
                                <Text>
                                    each participant was dealt a set of cards showing a stakeholder's likes, dislikes and effects to/by humans
                                </Text>
                            </div>
                    </div>
                </Row>
                <Row className="m80-t">
                     <div>
                        <Image src={require("../assets/projects/sensable/sensable_49.png")}/>
                            <div  className="m16-t m16-b">
                                <Text>
                                    Some of the major themes which came out during brainstorming. I personally like the idea of a pet very much, how a pet is almost considered like family
                                </Text>
                            </div>
                    </div>
                </Row>
                <Row className="m80-t">
                     <div>
                        <Image src={require("../assets/projects/sensable/sensable_50.png")}/>
                            <div  className="m16-t m16-b">
                                <Text>
                                    Parque del Prado, a park in Curridabat where I did some intercept interviews
                                </Text>
                            </div>
                    </div>
                </Row>
                <Row className="m80-t" justify="space-between">
                    <Col xs={24} sm={24} md={24} lg={16} xl={16}>
                        <div>
                            <Image className="m24-t" src={require("../assets/projects/sensable/sensable_51.png")}/>
                            <div  className="m16-t m16-b">
                                <Text>
                                    A sketch of the park while in it, one can see the direction the wind blows. It is by observing we learn so much
                                </Text>
                            </div>
                        </div> 
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={7} xl={7}>
                        <div>
                            <Image className="m24-t" src={require("../assets/projects/sensable/sensable_52.png")}/>
                            <div  className="m16-t m16-b">
                                <Text>
                                    Map of the human pathway in the park, the dashed line is the ant trail and the hexagon is the stage
                                </Text>
                            </div>
                        </div> 
                    </Col>
                    
                </Row>
                <Row className="m80-t">
                     <div>
                        <Image src={require("../assets/projects/sensable/sensable_53.png")}/>
                            <div  className="m16-t m16-b">
                                <Text className="imgDesc">
                                    Initial concept I came up with, <strong>"Citizen Growth"</strong> - where the park is a city and all the inhabitants it's citizens contributing to the society additively
                                </Text>
                            </div>
                    </div>
                </Row>

                        
                        <Row className="m48-t" justify="space-between" align="start">
                            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                                <div>
                                    <Image src={require("../assets/projects/sensable/sensable_59.png")}/>
                                    <div  className="m16-t m16-b">
                                        <Text  className="imgDesc m24-t">
                                            I then started wondering what if every human had a plant pet, which they would take everywhere with them
                                        </Text>
                                    </div>
                                </div>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                                <div>
                                    <Image src={require("../assets/projects/sensable/sensable_60.png")}/>
                                    <div  className="m16-t m16-b">
                                        <Text  className="imgDesc m24-t">
                                            This pet would tell them when it's time to go out, give them all nature updates etc.
                                        </Text>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row className="m48-t" justify="space-between" align="start">

                            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                                <div>
                                    <Image src={require("../assets/projects/sensable/sensable_61.png")}/>
                                    <div  className="m16-t m16-b">
                                        <Text  className="imgDesc m24-t">
                                            When it needs light, it will ask the human to take it outside for a walk, where it can play with it's other friends and help the human explore the green areas
                                        </Text>
                                    </div>
                                </div>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                                <div>
                                    <Image src={require("../assets/projects/sensable/sensable_62.png")}/>
                                    <div  className="m16-t m16-b">
                                        <Text  className="imgDesc m24-t">
                                            It could also carry waste and spread it near ant nests as the waste from ant nest is a good biodegrading catalyst
                                        </Text>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row className="m120-t">
                            <Title>Prototype</Title>
                        </Row>
                        <Row className="m48-t" justify="space-between" align="start">
                            <div>
                                    <Image src={require("../assets/projects/sensable/sensable_64.png")}/>
                                    <div  className="m16-t m16-b">
                                        <Text  className="imgDesc">
                                            3d printed a quadraped to imitate a plant pet, this would carry a plant
                                        </Text>
                                    </div>
                                </div>
                        </Row>

                        <Row justify="space-between">
                            <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                                <div className="m48-t">
                                    <Image src={require("../assets/projects/sensable/sensable_13.gif")}/>
                                    <div  className="m16-t m16-b">
                                        <Text  className="imgDesc">
                                            trying to move
                                        </Text>
                                    </div>
                                </div>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                                <div className="m48-t">
                                    <Image src={require("../assets/projects/sensable/sensable_14.gif")}/>
                                    <div  className="m16-t m16-b">
                                        <Text  className="imgDesc">
                                            almost there...
                                        </Text>
                                    </div>
                                </div>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={7} xl={7}>
                                <div className="m48-t">
                                    <Image src={require("../assets/projects/sensable/sensable_15.gif")}/>
                                    <div  className="m16-t m16-b">
                                        <Text  className="imgDesc">
                                            there you go, it's walking now
                                        </Text>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <Row justify="space-between" align="start">
                            <Col xs={24} sm={24} md={24} lg={7} xl={7}>
                                <div className="m48-t">
                                    <Image src={require("../assets/projects/sensable/sensable_105.gif")}/>
                                    <div  className="m16-t m16-b">
                                        <Text  className="imgDesc">
                                            Bodystorming voice commands with the pet
                                        </Text>
                                    </div>
                                </div>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={16} xl={16}>
                                <div className="m48-t">
                                    <Image src={require("../assets/projects/sensable/sensable_17.gif")}/>
                                    <div  className="m16-t m16-b">
                                        <Text  className="imgDesc">
                                            Although I liked this robot, what I really liked was this relationship emerging between the plant and me, which would take me out to discover green areas. I decided to drop the robot, as it was clunky, difficult to be carried around and started looking at different stages in a life of a plant
                                        </Text>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <Row className="m80-t">

                        <Text className="HMWDark">
                        How might humans be more aware of their environment through fostering a plant such that they take mindful decisions?
                                    </Text>
                        </Row>

                        <Row justify="space-between">
                            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                                <div>
                                    <Image className="m48-t" src={require("../assets/projects/sensable/sensable_65.png")}/>
                                    <div  className="m16-t m16-b">
                                        <Text  className="imgDesc">
                                            with the reframed How Might We, it was going to be a plant which would help a human go out and sense more
                                        </Text>
                                    </div>
                                </div>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                                <div>
                                    <Image className="m48-t" src={require("../assets/projects/sensable/sensable_66.png")}/>
                                    <div  className="m16-t m16-b">
                                        <Text  className="imgDesc">
                                            since it was now smaller, what all possible spaces could it grow in
                                        </Text>
                                    </div>
                                </div>
                            </Col>
                        </Row>
            </Col>
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
        </Row>

        
        <Row className="whiteBG">
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
            <Col xs={22} sm={22} md={22} lg={18} xl={18}>

                <Row justify="space-between m80-t">
                    <div>
                        <Image src={require("../assets/projects/sensable/sensable_67.png")}/>
                            <div  className="m16-t m16-b">
                                <Text  className="imgDesc whiteBGTitle">
                                    I then chanced upon Air plants during my research and found that these plants do not need any soil to grow and pull their nutrients from the air
                                </Text>
                            </div>
                    </div>
                </Row>

                <Row justify="space-between m48-t">
                    <div>
                        <Image src={require("../assets/projects/sensable/sensable_68.png")}/>
                            <div  className="m16-t m16-b">
                                <Text  className="imgDesc whiteBGTitle">
                                    A quick search online, led me to many ways people air plants at home and also how resilient are they
                                </Text>
                            </div>
                    </div>
                </Row>

                <Row justify="space-between">
                    <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                        <div>
                            <Image className="m48-t" src={require("../assets/projects/sensable/sensable_69.png")}/>
                                <div  className="m16-t m16-b">
                                    <Text  className="imgDesc whiteBGTitle">
                                        some plant inspired jewelry I found for my mood-board
                                    </Text>
                                </div>
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                        <div>
                            <Image className="m48-t" src={require("../assets/projects/sensable/sensable_70.png")}/>
                                <div  className="m16-t m16-b">
                                    <Text  className="imgDesc whiteBGTitle">
                                        more mood-board previews, the one with two balls on the white dress got a lot of attention when I asked around
                                    </Text>
                                </div>
                        </div>
                    </Col>
                    
                </Row>

                <Row justify="space-between m48-t">
                    <div>
                        <Image src={require("../assets/projects/sensable/sensable_71.png")}/>
                            <div  className="m16-t m16-b">
                                <Text  className="imgDesc whiteBGTitle">
                                    Nitin trying out the empathy wearable. It vibrates when near a green area. For testing I had put geo-fences in my house and one in a friend's house, it would vibrate when I would walk to my friend's place. Contains 2 vibration motors, they were too close for one to distinguish which one is vibrating. Therefore I decided to split the wearable into 2, wherein one would get a clear direction
                                </Text>
                            </div>
                    </div>
                </Row>

                <Row justify="space-between m48-t">
                    <div>
                        <Image src={require("../assets/projects/sensable/sensable_72.png")}/>
                            <div  className="m16-t m16-b">
                                <Text  className="imgDesc whiteBGTitle">
                                    Scraped green areas as polygonal geo-fences from overpass turbo API to be fed into p5
                                </Text>
                            </div>
                    </div>
                </Row>

                <Row justify="space-between">
                    <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                        <div>
                            <Image className="m48-t" src={require("../assets/projects/sensable/sensable_73.png")}/>
                                <div  className="m16-t m16-b">
                                    <Text  className="imgDesc whiteBGTitle">
                                        Trying out epaulettes vs stick on necklaces - decided to with stick on necklaces
                                    </Text>
                                </div>
                        </div>
                    </Col>
                        
                    <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                        <div>
                            <Image className="m48-t" src={require("../assets/projects/sensable/sensable_18.gif")}/>
                                <div  className="m16-t m16-b">
                                    <Text  className="imgDesc whiteBGTitle">
                                        Stitched some fabric on cardboard to understand the feel
                                    </Text>
                                </div>
                        </div>
                    </Col>
                    
                </Row>

                <Row justify="space-between m48-t">
                    <div>
                        <Image src={require("../assets/projects/sensable/sensable_74.png")}/>
                            <div  className="m16-t m16-b">
                                <Text  className="imgDesc whiteBGTitle">
                                    More exploration with jewelry materials. Was trying to grow plants in the center so made a hole, but later on decided to drop it as plants need more freedom to grow
                                </Text>
                            </div>
                    </div>
                </Row>

                <Row justify="space-between" >
                    <Col xs={24} sm={24} md={24} lg={6} xl={6} className="m48-t">
                        <div>
                            <Image src={require("../assets/projects/sensable/sensable_32.gif")}/>
                                <div  className="m16-t m16-b">
                                    <Text  className="imgDesc whiteBGTitle">
                                        Started making an icosahedron to house the plants
                                    </Text>
                                </div>
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={6} xl={6} className="m48-t">
                        <div>
                            <Image src={require("../assets/projects/sensable/sensable_91.png")}/>
                                <div  className="m16-t m16-b">
                                    <Text  className="imgDesc whiteBGTitle">
                                        made with 20 triangles, it looks like a hexagon from any perspective
                                    </Text>
                                </div>
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={6} xl={6} className="m48-t">
                        <div>
                            <Image src={require("../assets/projects/sensable/sensable_33.gif")}/>
                                <div  className="m16-t m16-b">
                                    <Text  className="imgDesc whiteBGTitle">
                                        sanding off each side of the triangles to stick them
                                    </Text>
                                </div>
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={5} xl={5} className="m48-t">
                        <div>
                            <Image src={require("../assets/projects/sensable/sensable_92.png")}/>
                                <div  className="m16-t m16-b">
                                    <Text  className="imgDesc whiteBGTitle">
                                        difference between sanded and un-sanded triangles
                                    </Text>
                                </div>
                        </div>
                    </Col>
                    
                </Row>

                <Row justify="space-between">
                    <Col xs={24} sm={24} md={24} lg={6} xl={6} className="m48-t">
                        <div>
                            <Image src={require("../assets/projects/sensable/sensable_93.png")}/>
                                <div  className="m16-t m16-b">
                                    <Text  className="imgDesc whiteBGTitle">
                                        Sticking them together - using a mix of adhesive materials
                                    </Text>
                                </div>
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={6} xl={6} className="m48-t">
                        <div>
                            <Image src={require("../assets/projects/sensable/sensable_34.gif")}/>
                                <div  className="m16-t m16-b">
                                    <Text  className="imgDesc whiteBGTitle">
                                        Sanding of the final shape
                                    </Text>
                                </div>
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={6} xl={6} className="m48-t">
                        <div>
                            <Image src={require("../assets/projects/sensable/sensable_94.png")}/>
                                <div  className="m16-t m16-b">
                                    <Text  className="imgDesc whiteBGTitle">
                                        Here it is!
                                    </Text>
                                </div>
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={5} xl={5} className="m48-t">
                        <div>
                            <Image src={require("../assets/projects/sensable/sensable_95.png")}/>
                                <div  className="m16-t m16-b">
                                    <Text  className="imgDesc whiteBGTitle">
                                        polished vs unpolished
                                    </Text>
                                </div>
                        </div>
                    </Col>
                    
                </Row>

                <Row justify="space-between" className="m48-t">
                    <div>
                        <Image src={require("../assets/projects/sensable/sensable_75.png")}/>
                            <div  className="m16-t m16-b">
                                <Text  className="imgDesc whiteBGTitle">
                                    Woodworking a box for the jewelry, had to feel like they were from the same family of products
                                </Text>
                            </div>
                    </div>
                </Row>

                <Row justify="space-between" className="m48-t">
                    <Col xs={24} sm={24} md={24} lg={8} xl={8} className="m48-t">
                        <div>
                            <Image src={require("../assets/projects/sensable/sensable_16.gif")}/>
                                <div  className="m16-t m16-b">
                                    <Text  className="imgDesc whiteBGTitle">
                                        Visualization of leaves harvested by leaf-cutter ants
                                    </Text>
                                </div>
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={8} xl={8} className="m48-t">
                        <div>
                            <Image src={require("../assets/projects/sensable/sensable_11.gif")}/>
                                <div  className="m16-t m16-b">
                                    <Text  className="imgDesc whiteBGTitle">
                                        Time in seconds relative to no. leaves harvested by leaf-cutter ants
                                    </Text>
                                </div>
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={7} xl={7} className="m48-t">
                        <div>
                            <Image src={require("../assets/projects/sensable/sensable_12.gif")}/>
                                <div  className="m16-t m16-b">
                                    <Text  className="imgDesc whiteBGTitle">
                                        converting the frequency of leaves harvested to a physical motion - sound
                                    </Text>
                                </div>
                        </div>
                    </Col>
                </Row>

                <Row justify="space-between">
                    <Col xs={24} sm={24} md={24} lg={8} xl={8} className="m48-t">
                        <Image src={require("../assets/projects/sensable/sensable_25.gif")}/>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={8} xl={8} className="m48-t">
                        <Image src={require("../assets/projects/sensable/sensable_26.gif")}/>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={7} xl={7} className="m48-t">
                        <Image src={require("../assets/projects/sensable/sensable_27.gif")}/>
                    </Col>
                </Row>

                <Row justify="space-between">
                    <Col xs={24} sm={24} md={24} lg={12} xl={12} className="m48-t">
                        <div>
                            <Image src={require("../assets/projects/sensable/sensable_20.gif")}/>
                                <div  className="m16-t m16-b">
                                    <Text  className="imgDesc whiteBGTitle">
                                        I was very inspired by how the natural movements of leaves and branches are and wanted to imitate that based on the leaves harvested by the ants
                                    </Text>
                                </div>
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={11} xl={11} className="m48-t">
                        <div>
                            <Image src={require("../assets/projects/sensable/sensable_21.gif")}/>
                                <div  className="m16-t m16-b">
                                    <Text  className="imgDesc whiteBGTitle">
                                        servos moving in accordance with the ant activity
                                    </Text>
                                </div>
                        </div>
                    </Col>
                    
                </Row>

                <Row justify="space-between">
                    <Col xs={24} sm={24} md={24} lg={12} xl={12} className="m48-t">
                        <div>
                            <Image src={require("../assets/projects/sensable/sensable_77.png")}/>
                                <div  className="m16-t m16-b">
                                    <Text  className="imgDesc whiteBGTitle">
                                        Connecting leaves collected from the garden
                                    </Text>
                                </div>
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={11} xl={11} className="m48-t">
                        <div>
                            <Image src={require("../assets/projects/sensable/sensable_35.gif")}/>
                                <div  className="m16-t m16-b">
                                    <Text  className="imgDesc whiteBGTitle">
                                        sounds good! but the servos are too noisy
                                    </Text>
                                </div>
                        </div>
                    </Col>
                </Row>

                <Row justify="space-between">
                    <Col xs={24} sm={24} md={24} lg={10} xl={10} className="m48-t">
                        <div>
                            <Image src={require("../assets/projects/sensable/sensable_78.png")}/>
                                <div  className="m16-t m16-b">
                                    <Text  className="imgDesc whiteBGTitle">
                                        time to box the servos
                                    </Text>
                                </div>
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={13} xl={13} className="m48-t">
                        <div>
                            <Image src={require("../assets/projects/sensable/sensable_23.gif")}/>
                                <div  className="m16-t m16-b">
                                    <Text  className="imgDesc whiteBGTitle">
                                        better! less noisier
                                    </Text>
                                </div>
                        </div>
                    </Col>
                    
                </Row>

                <Row justify="space-between">
                    <Col xs={24} sm={24} md={24} lg={12} xl={12} className="m48-t">
                        <div>
                            <Image src={require("../assets/projects/sensable/sensable_80.png")}/>
                                <div  className="m16-t m16-b">
                                    <Text  className="imgDesc whiteBGTitle">
                                        collecting more leaves from the neighborhood, these are the leaves which are usually eaten by the ants
                                    </Text>
                                </div>
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={11} xl={11} className="m48-t">
                        <div>
                            <Image src={require("../assets/projects/sensable/sensable_79.png")}/>
                                <div  className="m16-t m16-b">
                                    <Text  className="imgDesc whiteBGTitle">
                                        fixing the new leaves
                                    </Text>
                                </div>
                        </div>
                    </Col>
                    
                </Row>

                <Row justify="space-between">
                    <Col xs={24} sm={24} md={24} lg={12} xl={12} className="m48-t">
                        <div>
                            <Image src={require("../assets/projects/sensable/sensable_37.gif")}/>
                                <div  className="m16-t m16-b">
                                    <Text  className="imgDesc whiteBGTitle">
                                        freshly collected leaves in action
                                    </Text>
                                </div>
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={11} xl={11} className="m48-t">
                        <div>
                            <Image src={require("../assets/projects/sensable/sensable_28.gif")}/>
                                <div  className="m16-t m16-b">
                                    <Text  className="imgDesc whiteBGTitle">
                                        mirrored over display, it garnered a lot of attention at the studio
                                    </Text>
                                </div>
                        </div>
                    </Col>
                    
                </Row>

                <Row justify="space-between">
                    <Col xs={24} sm={24} md={24} lg={12} xl={12} className="m48-t">
                        <div>
                            <Image src={require("../assets/projects/sensable/sensable_38.gif")}/>
                                <div  className="m16-t m16-b">
                                    <Text  className="imgDesc whiteBGTitle">
                                        Trying to hit a bowl of water with a solenoid motor based on the moisture in the ground. The visualization was very poor and wouldn't attract attention
                                    </Text>
                                </div>
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={11} xl={11} className="m48-t">
                        <div>
                            <Image src={require("../assets/projects/sensable/sensable_81.png")}/>
                                <div  className="m16-t m16-b">
                                    <Text  className="imgDesc whiteBGTitle">
                                        Collected some stems to try another idea I had, where in leaf would brush against some stems
                                    </Text>
                                </div>
                        </div>
                    </Col>
                    
                </Row>

                <Row justify="space-between">
                    <Col xs={24} sm={24} md={24} lg={8} xl={8} className="m48-t">
                        <div>
                            <Image src={require("../assets/projects/sensable/sensable_36.gif")}/>
                                <div  className="m16-t m16-b">
                                    <Text  className="imgDesc whiteBGTitle">
                                        Leaves on stems - the leaves would dry and break over time
                                    </Text>
                                </div>
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={8} xl={8} className="m48-t">
                        <div>
                            <Image src={require("../assets/projects/sensable/sensable_30.gif")}/>
                                <div  className="m16-t m16-b">
                                    <Text  className="imgDesc whiteBGTitle">
                                        Moved to using wood only and hitting it with wood
                                    </Text>
                                </div>
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={7} xl={7} className="m48-t">
                        <div>
                            <Image src={require("../assets/projects/sensable/sensable_31.gif")}/>
                                <div  className="m16-t m16-b">
                                    <Text  className="imgDesc whiteBGTitle">
                                        Liked how it took the form of a chime
                                    </Text>
                                </div>
                        </div>
                    </Col>

                </Row>

                <Row justify="space-between">
                    <div>
                        <Image src={require("../assets/projects/sensable/sensable_82.png")}/>
                            <div  className="m16-t m16-b">
                                <Text  className="imgDesc whiteBGTitle">
                                Finally, wanted to add some water in the installation as it was pertaining to moisture. Dug some shallow pots in the ground and hung a stone from each chime on the surface of the water
                                </Text>
                            </div>
                    </div>
                </Row>

                <Row justify="space-between m48-t">
                    <div>
                        <Image src={require("../assets/projects/sensable/sensable_89.jpg")}/>
                            <div  className="m16-t m16-b">
                                <Text  className="imgDesc whiteBGTitle">
                                    Directions for how to become more sensable - soft instructions
                                </Text>
                            </div>
                    </div>
                </Row>

                <Row justify="space-between m48-t">
                    <div>
                        <Image src={require("../assets/projects/sensable/sensable_83.png")}/>
                            <div  className="m16-t m16-b">
                                <Text  className="imgDesc whiteBGTitle">
                                    Had to update with a graphic - as no one who held it knew where/how to wear it
                                </Text>
                            </div>
                    </div>
                </Row>

                <Row justify="space-between m48-t m120-b">
                    <div>
                        <Image src={require("../assets/projects/sensable/sensable_84.png")}/>
                            <div  className="m16-t m16-b">
                                <Text  className="imgDesc whiteBGTitle">
                                    sensable is connected to other installations through firebase, sharing GPS location over p5
                                </Text>
                            </div>
                    </div>
                </Row>
            </Col>
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
        </Row>
        
        <Row className="m80-t m80-b">
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
            <Col xs={22} sm={22} md={22} lg={18} xl={18}>

                <Row>
                    
                </Row>

                <Row justify="space-between">
                    <Col xs={24} sm={24} md={24} lg={12} xl={12} className="m24-t">
                        <Space size={4} direction="vertical">
                        <Text className="projectTitle m16-b">Learnings</Text>
                            <Text>
                                <ul>
                                    <li>This will bring change in long term. More sensable people would equate to more mindful decision making, elect better leader</li>
                                    <li>People want more options in fashion - based on occasion</li>
                                    <li>Strong relationships lead to emergence of unprecedented behavioral changes</li>
                                    <li>Very difficult to non-anthroposize and yet create something invasive while making installations</li>
                                    <li>Nature has a lot to teach us</li>
                                </ul>
                            </Text>
                        </Space>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={11} xl={11} className="m24-t">
                        <Space size={4} direction="vertical">
                            <Text className="projectTitle m16-b">Next steps</Text>
                            <Text>
                                <ul>
                                    <li>Walkability data shared with government to indicate well-being of citizens</li>
                                    <li>Viability of growing flowers, herbs and vegetables</li>
                                    <li>Natural disaster alerts since people are connected to the earth like never before</li>
                                </ul>
                            </Text>
                        </Space>
                    </Col>
                </Row>

            </Col>
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
        </Row>
    </div>
  );
}

export default sensable;